export default __webpack_public_path__ + "media/contribution.f65ddeb7.svg";